export default "__VITE_ASSET__CuEvIyZ9__"